import React, { useState, useRef, useEffect } from "react";
import SharePopup from "./SharePopup";
import ReportAssetModal from "../marketplace/ReportAssetModal";

const Auctions_dropdown = ({ classes, share_to, assetId, assetName }) => {
  const [dropdownShow, setDropdownShow] = useState(false);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const wrapperRef = useRef(null);

  // Close on outside click / Escape (only while open)
  useEffect(() => {
    if (!dropdownShow) return;
    const onPointer = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setDropdownShow(false);
      }
    };
    const onKey = (e) => {
      if (e.key === "Escape") setDropdownShow(false);
    };
    document.addEventListener("mousedown", onPointer);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onPointer);
      document.removeEventListener("keydown", onKey);
    };
  }, [dropdownShow]);

  const handleShareClick = () => {
    setShowSharePopup(true);
    setDropdownShow(false);
  };

  const handleReportClick = () => {
    setShowReportModal(true);
    setDropdownShow(false);
  };

  return (
    <>
      <div className="relative" ref={wrapperRef}>
        <div className={classes}>
          <button
            type="button"
            aria-haspopup="menu"
            aria-expanded={dropdownShow}
            aria-label="More options"
            onClick={() => setDropdownShow((v) => !v)}
            className="inline-flex h-8 w-8 items-center justify-center rounded-lg text-jacarta-500 transition-colors hover:bg-jacarta-100 dark:text-jacarta-200 dark:hover:bg-jacarta-600"
          >
            <svg
              width="16"
              height="4"
              viewBox="0 0 16 4"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="2" cy="2" r="2"></circle>
              <circle cx="8" cy="2" r="2"></circle>
              <circle cx="14" cy="2" r="2"></circle>
            </svg>
          </button>
        </div>

        <div
          role="menu"
          className={`absolute right-0 top-[calc(100%+0.5rem)] z-30 w-48 max-w-[calc(100vw-2rem)] origin-top-right overflow-hidden rounded-xl border border-jacarta-100 bg-white p-1.5 shadow-xl ring-1 ring-black/5 transition-all duration-150 ease-out dark:border-jacarta-600 dark:bg-jacarta-800 dark:ring-white/10 ${
            dropdownShow
              ? "visible scale-100 opacity-100"
              : "invisible scale-95 opacity-0"
          }`}
        >
          <button
            type="button"
            role="menuitem"
            onClick={handleShareClick}
            className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left text-sm font-medium text-jacarta-700 transition-colors hover:bg-jacarta-50 dark:text-white dark:hover:bg-jacarta-700"
          >
            <svg
              className="h-4 w-4 flex-shrink-0 text-jacarta-400 dark:text-jacarta-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
              />
            </svg>
            Share
          </button>

          {!!assetId && (
            <>
              <div className="my-1 h-px bg-jacarta-100 dark:bg-jacarta-600" />
              <button
                type="button"
                role="menuitem"
                onClick={handleReportClick}
                className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left text-sm font-medium text-red-600 transition-colors hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-500/10"
              >
                <svg
                  className="h-4 w-4 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 3v1.5M3 21v-6m0 0l2.77-.693a9 9 0 016.208.682l.108.054a9 9 0 006.086.71l3.114-.732a48.524 48.524 0 01-.005-10.499l-3.11.732a9 9 0 01-6.085-.711l-.108-.054a9 9 0 00-6.208-.682L3 4.5M3 15V4.5"
                  />
                </svg>
                Report
              </button>
            </>
          )}
        </div>
      </div>

      {showSharePopup && (
        <SharePopup
          showSharePopup={showSharePopup}
          share_to={share_to || null}
          setShowSharePopup={setShowSharePopup}
        />
      )}
      {showReportModal && (
        <ReportAssetModal
          assetId={assetId}
          assetName={assetName}
          onClose={() => setShowReportModal(false)}
        />
      )}
    </>
  );
};

export default Auctions_dropdown;
